import { inject, Injectable } from "@angular/core";
import { GraphService } from "@app/kernel/graphql/services/graph.service";
import { Observable, map, first } from "rxjs";
import { IAllStepConfigurations } from "@app/applications/movements-management/shared/step-configuration/interfaces/step-configuration.interface";
import { STEP_CONFIGURATION_QUERY } from "../queries/step-configuration.query";

@Injectable()
export class StepConfigurationApiService {
  private readonly graphService = inject(GraphService);

  getStepsConfiguration(): Observable<IAllStepConfigurations> {
    return this.graphService
      .constructQuery<{ getAllStepConfiguration: IAllStepConfigurations }>(STEP_CONFIGURATION_QUERY, "getAllStepConfiguration")
      .pipe(
        first(),
        map(data => {
          if (data.errors?.length) {
            throw data.errors[0];
          }
          return data.data!.getAllStepConfiguration;
        })
      );
  }
}
